import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SpinnerService } from 'src/app/shared/spinner/spinner.service';

@Component({
    selector: 'app-test-form',
    templateUrl: './test-form.component.html',
    styleUrls: ['./test-form.component.scss'],
    standalone: false
})
export class TestFormComponent implements OnInit {
  urlQueryString: string = "";
  queryBody: any = {};
  isBrowser: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public dialogRef: any,
    public dialog: MatDialogRef<TestFormComponent>,
    public http: HttpClient,
    private spinner: SpinnerService,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) platformId?: Object
    ) {
      this.isBrowser = isPlatformBrowser(platformId);
      if(!this.isBrowser) return;
   }

  ngOnInit(): void {
    if(!this.isBrowser) return;
   
  }

  
}
